module.exports = "<footer class=\"footer\">\n  <div class=\"container footer__wrapper\">\n    <p class=\"footer__credits\" [innerHtml]=\"footerCredits\"></p>\n    <time class=\"footer__date\" datetime=\"2018\">2018</time>\n  </div>\n</footer>\n\n<template #template>\n    <h3>tempalte title</h3>\n    <section>tempalte section</section>\n    <footer>template footer</footer>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/partials/footer/footer.component.html
// module id = ./src/app/partials/footer/footer.component.html
// module chunks = main